export const IconUserError = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="IconUserError_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconUserError_svg__a)">
        <path d="M9 12q-1.65 0-2.825-1.175T5 8t1.175-2.825T9 4t2.825 1.175T13 8t-1.175 2.825T9 12m-8 6v-.8q0-.85.438-1.562.437-.713 1.162-1.088a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 9 13q1.65 0 3.25.387 1.6.388 3.15 1.163.724.375 1.162 1.087Q17 16.35 17 17.2v.8q0 .824-.587 1.413A1.93 1.93 0 0 1 15 20H3q-.824 0-1.412-.587A1.93 1.93 0 0 1 1 18M16.172 8.586 17.586 10l-1.414 1.414q-.3.3-.3.707t.3.707q.3.3.707.3.405 0 .707-.3L19 11.414l1.414 1.414q.3.3.707.3t.707-.3.3-.707q0-.405-.3-.707L20.414 10l1.414-1.414q.3-.3.3-.707t-.3-.707q-.3-.3-.707-.3-.405 0-.707.3L19 8.586l-1.414-1.414q-.3-.3-.707-.3t-.707.3q-.3.3-.3.707 0 .405.3.707" />
      </g>
    </svg>
  );
};
